/* eslint-disable react/prop-types */
// /CoreWrapper/cores/coreBackgroundColorOrGradient.js
import React from 'react'

const toArray = (v) => (Array.isArray(v) ? v : v ? [v] : [])

export function coreBackgroundColorOrGradient(BaseComponent) {
	const WithBackground = ({
		bgColors, // string | string[]
		bgColorsHover, // string | string[]
		bgAnimate, // bool (optional). default: multi-color => true
		bgDuration = '6s', // animation duration for animated background
		bgDegree = 120, // gradient angle
		className = '',
		style = {},
		...rest
	}) => {
		const colors = toArray(bgColors)
		const hoverColors = toArray(bgColorsHover)

		// no background at all
		if (!colors.length && !hoverColors.length) {
			return (
				<BaseComponent className={className} style={style} {...rest} />
			)
		}

		const hasMultiColors = colors.length > 1
		const hasMultiHover = hoverColors.length > 1

		const isAnimated =
			bgAnimate !== undefined && bgAnimate && hasMultiColors
		const isAnimatedHover =
			bgAnimate !== undefined && bgAnimate && hasMultiHover

		const angle = `${bgDegree}deg`

		const bg = hasMultiColors
			? `linear-gradient(${angle}, ${colors.join(',')})`
			: colors[0]

		const bgHover = hasMultiHover
			? `linear-gradient(${angle}, ${hoverColors.join(',')})`
			: hoverColors[0] || colors[0]

		const animatedClass = isAnimated ? 'wbk-bg-animated' : 'wbk-bg-static'
		const animatedHoverClass = isAnimatedHover
			? 'wbk-bg-hover-animated'
			: 'wbk-bg-hover-static'

		const mergedClassName = [
			'wbk-bg',
			hasMultiColors ? 'wbk-bg-gradient' : 'wbk-bg-color',
			hasMultiHover ? 'wbk-bg-hover-gradient' : 'wbk-bg-hover-color',
			animatedClass,
			animatedHoverClass,
			className
		]
			.filter(Boolean)
			.join(' ')

		const mergedStyle = {
			'--wbk-bg': bg,
			'--wbk-bg-hover': bgHover,
			'--wbk-bg-duration': bgDuration,
			transition: 'background 0.3s ease',
			...style
		}

		return (
			<BaseComponent
				className={mergedClassName}
				style={mergedStyle}
				{...rest}
			/>
		)
	}

	return WithBackground
}
